<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de acesso à funcionalidade">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/administracao/relatorio-acesso-funcionalidade/List'

export default {
    components: {List},
}
</script>